import React from 'react'

const Calendar = (props: any) => {
  return (
    <svg {...props} width="100%" height="100%" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3_53)">
        <path
          d="M30.25 5.625H7.75C7.12868 5.625 6.625 6.12868 6.625 6.75V29.25C6.625 29.8713 7.12868 30.375 7.75 30.375H30.25C30.8713 30.375 31.375 29.8713 31.375 29.25V6.75C31.375 6.12868 30.8713 5.625 30.25 5.625Z"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.75 3.375V7.875"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.25 3.375V7.875"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.625 12.375H31.375"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_53">
          <rect width="36" height="36" fill="white" transform="translate(1)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Calendar
